<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <mat-dialog-content class="referral-dialog" fxFlex>
    <div class="refer-icon">
      <i class="material-icons">card_giftcard</i>
    </div>

    <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
      <h3>Refer a business and get a $250 gift card when they sign!</h3>
      <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
        Error occurred
      </div>

      <app-mat-text-input [formControl]="getFormControl('yourName')" label="Your First and Last Name" name="yourName"
                          [submitted]="submitted"></app-mat-text-input>
      <app-mat-text-input [formControl]="getFormControl('yourEmail')" label="Your Email Address" name="yourEmail"
                          [submitted]="submitted"></app-mat-text-input>

      <h3>Tell us about your referral</h3>

      <app-mat-text-input [formControl]="getFormControl('firstName')" label="First Name" name="firstName"
                          [submitted]="submitted"></app-mat-text-input>
      <app-mat-text-input [formControl]="getFormControl('lastName')" label="Last Name" name="lastName"
                          [submitted]="submitted"></app-mat-text-input>
      <app-mat-text-input [formControl]="getFormControl('companyName')" label="Company Name" name="companyName"
                          [submitted]="submitted"></app-mat-text-input>

      <app-mat-text-input [formControl]="getFormControl('businessEmail')" label="Email" name="email"
                          [submitted]="submitted"></app-mat-text-input>
      <app-mat-phone-number-input [formControl]="getFormControl('phoneNumber')" label="Phone Number" name="phoneNumber"
                                  [submitted]="submitted"></app-mat-phone-number-input>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="onSubmit()" [promiseBtn]="buttonSubmitPromise">Submit</button>
    <button mat-button [mat-dialog-close]="false">Cancel</button>
  </mat-dialog-actions>
</div>
